module.exports = __webpack_public_path__ + "img/p2-7.267c5cf8.png";